"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _PrivacyPolicyTypes = _interopRequireDefault(require("../constants/PrivacyPolicyTypes"));

var _PrivacyModes = _interopRequireDefault(require("../constants/PrivacyModes"));

var CookieNotificationSettings = (0, _immutable.Record)({
  domain: null,
  enabled: true,
  id: null,
  label: null,
  path: null,
  privacyAcceptWording: null,
  privacyDefault: false,
  privacyDisclaimerWording: null,
  privacyDismissWording: null,
  privacyHideDecline: null,
  privacyPolicy: _PrivacyPolicyTypes.default.NO_REQUEST,
  privacyPolicyWording: null
}, 'CookieNotificationSettings');

CookieNotificationSettings.buildDefault = function (reportSettings) {
  return new CookieNotificationSettings({
    enabled: reportSettings.privacyMode === _PrivacyModes.default.PRODUCTION,
    label: _I18n.default.text('analyticsAndTracking.cookiePolicy.notificationPanel.defaultPolicyLabel'),
    privacyAcceptWording: reportSettings.privacyAcceptWording,
    privacyDefault: true,
    privacyDisclaimerWording: reportSettings.privacyDisclaimerWording,
    privacyDismissWording: reportSettings.privacyDismissWording,
    privacyPolicyWording: reportSettings.privacyPolicyWording,
    privacyHideDecline: reportSettings.privacyHideDecline,
    privacyPolicy: reportSettings.privacyPolicy
  });
};

CookieNotificationSettings.buildOverride = function (overrideSetting) {
  return new CookieNotificationSettings((0, _extends2.default)({}, overrideSetting));
};

CookieNotificationSettings.buildNew = function () {
  return new CookieNotificationSettings({
    label: _I18n.default.text('analyticsAndTracking.cookiePolicy.notificationPanel.newPolicyDefaults.policyLabel')
  });
};

CookieNotificationSettings.prototype.cookiesEnabled = function cookiesEnabled() {
  return this.privacyPolicy !== _PrivacyPolicyTypes.default.NO_COOKIES;
};

CookieNotificationSettings.prototype.notificationEnabled = function notificationEnabled() {
  return this.privacyPolicy === _PrivacyPolicyTypes.default.NOTIFY || this.privacyPolicy === _PrivacyPolicyTypes.default.REQUEST_CONSENT;
};

CookieNotificationSettings.prototype.requireOptIn = function requireOptIn() {
  return (this.privacyPolicy === _PrivacyPolicyTypes.default.REQUEST_CONSENT || this.privacyPolicy === _PrivacyPolicyTypes.default.NOTIFY) && !this.privacyHideDecline;
};

CookieNotificationSettings.prototype.policyKey = function requireOptIn() {
  switch (this.privacyPolicy) {
    case _PrivacyPolicyTypes.default.NO_COOKIES:
      return 'cookiesDisabled';

    case _PrivacyPolicyTypes.default.NO_REQUEST:
      return 'notificationDisabled';

    case _PrivacyPolicyTypes.default.NOTIFY:
      return 'notifyVisitors';

    case _PrivacyPolicyTypes.default.REQUEST_CONSENT:
      if (this.privacyHideDecline) {
        return 'notifyVisitors';
      }

      return 'requireOptIn';

    default:
      return null;
  }
};

var _default = CookieNotificationSettings;
exports.default = _default;
module.exports = exports.default;